import Vue from "vue";

export default {
	version: "1.4",
	base_url: window.location.origin,
	
	set_token: function(newToken) {
		window.localStorage.setItem("token", newToken);
		Vue.http.headers.common["Token"] = newToken;
	},
	set_active_factory_id: function(idFactory) {
		var parsedFactoryId = parseInt(idFactory);
		if (idFactory == null || idFactory === "" || isNaN(parsedFactoryId) || parsedFactoryId <= 0) {
			window.localStorage.removeItem("active_factory_id");
			delete Vue.http.headers.common["Acting-Factory-Id"];
			return;
		}
		var headerFactoryId = String(parsedFactoryId);
		window.localStorage.setItem("active_factory_id", headerFactoryId);
		Vue.http.headers.common["Acting-Factory-Id"] = headerFactoryId;
	},
	get_active_factory_id: function() {
		return window.localStorage.getItem("active_factory_id");
	},
	apply_active_factory_header: function() {
		var parsedFactoryId = parseInt(this.get_active_factory_id());
		if (!isNaN(parsedFactoryId) && parsedFactoryId > 0) {
			Vue.http.headers.common["Acting-Factory-Id"] = String(parsedFactoryId);
		} else {
			delete Vue.http.headers.common["Acting-Factory-Id"];
		}
	},
	get_token: function() {
		return window.localStorage.getItem("token");
	},
	is_logged_in: function() {
		var token = this.get_token();
		return token != null && token !== "";
	},
	logout: function(_rights) {
		this.set_token("");
		this.set_active_factory_id("");
		if (_rights && _rights.clear_rights) {
			_rights.clear_rights();
		}
	},
	verify_response: function(response, rights) {
		if (response.body.NotLogged) {
			this.logout(rights);
			return false;
		}
		return true;
	},
	verify_login_and_redirect: function(vueInstance) {
		if (!this.is_logged_in()) {
			vueInstance.$router.push("/");
		}
	}
};
